import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { publicRequest } from "../../requestMethods";
import { SellerIDContext } from "../../App";
import {
  initMetaPixel,
  trackMetaPageView,
  resetMetaPixelSession,
} from "../../utils/metaPixel";

/**
 * Loads per-seller Meta Pixel when enabled (public config). No-op for everyone else.
 * SPA PageView on route changes after init.
 */
const MetaPixelBootstrap = () => {
  const sellerID = useContext(SellerIDContext);
  const location = useLocation();
  const [pixelReady, setPixelReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setPixelReady(false);
    resetMetaPixelSession();

    const run = async () => {
      if (!sellerID) {
        return;
      }

      try {
        const res = await publicRequest.get(`public/meta-pixel/${sellerID}`);
        if (cancelled) return;

        const { enabled, pixelId } = res.data || {};
        if (!enabled || !pixelId) {
          return;
        }

        const started = await initMetaPixel(pixelId);
        if (cancelled || !started) return;
        setPixelReady(true);
      } catch {
        if (!cancelled) setPixelReady(false);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [sellerID]);

  useEffect(() => {
    if (!sellerID || !pixelReady) return;
    trackMetaPageView();
  }, [sellerID, pixelReady, location.pathname, location.search]);

  return null;
};

export default MetaPixelBootstrap;
